"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const OperationalUI_1 = __importDefault(require("../OperationalUI/OperationalUI")); // Wrap each ui component in its own theme provider to make sure the default
// Contiamo theme is always available. Props are passed along unaltered.
function wrapDefaultTheme(Comp) {
    return (props) => (React.createElement(OperationalUI_1.default, null,
        React.createElement(Comp, Object.assign({}, props))));
}
exports.default = wrapDefaultTheme;
//# sourceMappingURL=wrap-default-theme.js.map